<template>
  <div
    id="app"
    v-touch:right="onSwipeLeft"
  >
    <router-view v-if="loaded" />
    <div
      v-if="is_show_footer"
      class="footer "
    >
      <router-link
        to="/index"
        class="footer_item"
        :class="show_icon_type === 'home' ? 'footer_item_active' : ''"
      >
        <span class="footer_icon m1" />
        <!-- <p class="footer_info">
					{{$t('home.index')}}
				</p> -->
      </router-link>
			
      <router-link
        to="/vchoose"
        class="footer_item "
        :class="show_icon_type === 'girl' ? 'footer_item_active' : ''"
      >
        <span class="footer_icon m2" />
        <!-- 	<p class="footer_info">
					{{$t('sky.xuan')}}
				</p> -->
      </router-link>
      <router-link
        to="/grap"
        class="footer_item"
        :class="show_icon_type === 'item' ? 'footer_item_active' : ''"
      >
        <span class="footer_icon m3" />
        <!-- <p class="footer_info">
					{{$t('sky.ying')}}
				</p> -->
      </router-link>
      <router-link
        to="/vindex"
        class="footer_item"
        :class="show_icon_type === 'video' ? 'footer_item_active' : ''"
      >
        <span class="footer_icon m4" />
      </router-link>
      <router-link
        to="/user"
        class="footer_item"
        :class="show_icon_type === 'user' ? 'footer_item_active' : ''"
      >
        <span class="footer_icon m5" />
        <!-- <p class="footer_info">
					{{$t('sky.ying')}}
				</p> -->
      </router-link>
      <!-- 	
				
			<router-link to="/" class="footer_item" :class="show_icon_type === 'index' ? 'footer_item_active' : ''">
				<span class="footer_icon footer_icon_home" />
				<p class="footer_info">
					{{$t('home.index')}}
				</p>
			</router-link>
			<router-link to="/order" class="footer_item" :class="show_icon_type === 'order' ? 'footer_item_active' : ''">
				<span class="footer_icon footer_icon_list" />
				<p class="footer_info">
					{{$t('feng.orders')}}
				</p>
			</router-link> -->
			
      <!-- <router-link to="/item" class="footer_item ismid" :class="show_icon_type === 'item' ? 'footer_item_active' : ''">
				<div class="itimg">
					<van-icon v-if="show_icon_type == 'item'" name="cart-circle" size="35" class="icon"/>
					<van-icon v-if="show_icon_type != 'item'" name="cart-circle-o" size="35" class="icon"/>
				</div>
				<p class="footer_info">
					{{$t('feng.area')}}
				</p>
			</router-link> -->
      <!-- <router-link to="/ads" class="footer_item" :class="show_icon_type === 'ads' ? 'footer_item_active' : ''">
				<span class="footer_icon footer_icon_star" />
				<p class="footer_info">
					{{$t('feng.ads')}}
				</p>
			</router-link>
			<router-link to="/moneybag" class="footer_item" :class="show_icon_type === 'moneybag' ? 'footer_item_active' : ''">
				<span class="footer_icon footer_icon_bag" />
				<p class="footer_info">
					{{$t('user.myWallet')}}
				</p>
			</router-link> -->
      <!-- <router-link to="/user" class="footer_item" :class="show_icon_type === 'user' ? 'footer_item_active' : ''">
				<span class="footer_icon footer_icon_user" />
				<p class="footer_info">
					{{$t('home.my')}}
				</p>
			</router-link> -->
    </div>
    <div
      v-show="real_name"
      class="real_name_mask"
    >
      <div class="real_box">
        <div class="tit" />
        <p class="tips">
          {{ $t('index.moneyset') }}
        </p>
        <div
          class="basic_btn"
          @click="real_name = false"
        >
          {{ $t('index.setnow') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import {
		Icon,
		Popup,
		Dialog
	} from 'vant';
	import Fetch from "./utils/fetch";
	Vue.use(Icon).use(Popup);
	export default {
		name: 'App',
		data() {
			return {
				show_icon_type: 'index',
				msg:null,
				show:false,
				real_name: false,
				is_show_down_app: true,
				is_show_footer: true,
				sync_timer: null,
				app: {},
				loaded:false
			}
		},
		updated() {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
		},
		mounted() {
			this.start();
		},
		methods: {
			onSwipeLeft (even,start,end) {
				console.log();
				if(end['X']-start['X']>60){
					this.$router.go(-1);
				}
			},
			bigNumeber(str) {
				var str = str.toString();
				var strs = str.split(".");
				var s1 = strs[0] || 0;
				var s2 = strs[1] || "00"
				return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
			},
			numFilter(value) {
				let transformVal = parseFloat(value).toFixed(3)
				let realVal = transformVal.substring(0, transformVal.length - 1)
				return parseFloat(realVal)
			},
			footer: function(type = 'index', show_footer = true) {
				if (type == 'walfare') {
					document.getElementById('app').style.paddingBottom = '0';
				} else {
					document.getElementById('app').style.paddingBottom = '1.333333rem';
				}
				this.show_icon_type = type;
				this.is_show_footer = show_footer;
			},
			start() {
				Fetch("/index/webconfig").then((r) => {
					this.app = r.data;
					window.document.title = r.data.title;
				  this.$i18n.locale = r.data.lang;
				  localStorage.setItem("lang", r.data.lang);
				  localStorage.setItem("moneyMark", r.data.money_mark);
				  this.loaded = true;
				});

				setTimeout(()=>{
				  this.sync()
				},2000)
			},
			closeDownApp() {
				this.is_show_down_app = false;
			},
			sync() {
				Fetch("/index/sync", {}, null, false).then((r) => {
				  if (r.data>0) {
					this.openNoticeDialog(r.data);
				  }
				});
			},
			close() {
				this.show_anwser = false;
			},
      openNoticeDialog(num) {
        Dialog.confirm({
			confirmButtonText: this.$t('utils.confirm'),
			cancelButtonText: this.$t('utils.cancel'),
			title: this.$t('notice.message'),
			message: num+" "+this.$t('notice.unRead')
        }).then(() => {
          this.$router.push('/notice');
        }).catch(() => {

        });
			},
		}
	}
</script>
<style lang="less">

	@import "./assets/font/font.css";
	.kefu {
		width: 60px;
		height: 60px;
		position: fixed;
		z-index: 10;
		right: 13px;
		bottom: 80px;
		transition: all 1s;
		opacity: 1;
		transform: translateX(0);
		z-index: 80;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.kefu.kefu_hide {
		transform: translateX(70%);
		opacity: 0.7;
	}

	.numberFont {
		font-family: barlow !important;
		font-size: 15px !important;
		font-weight: bold !important;
		span:nth-of-type(3) {
			font-size: 14px !important;
		}
		span:nth-of-type(4) {
			font-size: 12px !important;
		}
	}

	html,
	body {
		width: 100%;
		height: 100%;
		overflow-y: scroll;
	}

	html::-webkit-scrollbar,
	body::-webkit-scrollbar {
		width: 0px;
		height: 0px;
	}

	body {
		margin: 0;
	}

	.bigNum {
		font-size: 18px !important;
	}

	.fh {
		font-size: 12px !important;
	}

	.larfont .fh {
		margin-top: 3px;
	}

	.wan {
		font-size: 14px;
		margin-top: 2px;
	}

	.numberFontBold {
		span:first-child {
			font-size: 12px;
			margin-top: 4px;
		}

		span:last-child {
			margin-top: 2px;
		}
	}

	#app {
		overflow-x: hidden;
		padding-bottom: 0px !important;
		min-height: 100%;
		height: auto;
		width: 100%;
		max-width: 375px;
		background-color: #fff5e3;
		max-width: 720px;
		margin: auto;
		background:linear-gradient(180deg, #f3f9f8, #ebf5f3);
		color: #533126;
		
	}
	@media screen and (min-width: 768px) {
		/* Keep the desktop app inside a fixed 650px canvas. */
		html {
			font-size: 65px !important;
		}

		body {
			min-height: 100vh;
			background: #f6f0e7;
		}

		#app {
			width: 650px !important;
			max-width: 650px !important;
			min-height: 100vh;
			margin: 0 auto;
			box-shadow: 0 0 26px rgba(74, 43, 20, .12);
		}

		#app .footer {
			width: 650px !important;
			max-width: 650px !important;
			left: 50%;
			right: auto;
			transform: translateX(-50%);
		}
	}

	#app .download_box {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		position: fixed;
		margin: 0 auto;
		left: 0;
		right: 0;
		height: 45px;
		width: 100%;
		max-width: 375px;
		background: rgba(0, 0, 0, 0.5);
		bottom: 50px;
		padding: 0 3.6%;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		z-index: 10;
	}

	#app .download_box .down {
		-webkit-box-flex: 1;
		-ms-flex: 1 1 auto;
		flex: 1 1 auto;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		padding-right: 10px;
	}

	#app .download_box .down .down_left {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}

	#app .download_box .down .down_left .app_logo {
		display: inline-block;
		width: 40px;
		height: 40px;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		background-image: url(./views/images/home/app_logo.svg);
		margin-right: 14px;
		;
	}

	#app .download_box .down .down_left .app_info {
		font-size: 12px;
		color: #fff;
		line-height: 1.5;
		;
	}

	#app .download_box .down .right {
		background: #D8232C;
		padding: 5px 5px;
		color: #ffffff;
		border-radius: 5px;
		font-size: 12px;
	}

	#app .download_box .close_down {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 20px;
		flex: 0 0 20px;
		height: 45px;
		;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		background-image: url(./views/images/home/close.svg);
	}

	#app .footer {
		position: fixed;
		margin: 0 auto;
		left: 0;
		right: 0;
		-webkit-box-flex: 0;
		-ms-flex: 0 0 48px;
		flex: 0 0 48px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: distribute;
		justify-content: space-around;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		min-height: 64px;
		box-sizing: border-box;
		padding: 6px 4px calc(6px + env(safe-area-inset-bottom));
		background: rgba(248, 252, 251, .98) !important;
		border-top: 1px solid #b9dcd8;
		box-shadow: 0 -8px 20px rgba(8, 58, 66, .12);
		width: 100%;
		max-width: 750px;
		bottom: 0;
		// height: 60px;
		z-index: 1000;
	}

	#app .footer .footer_item {
		flex: 1 1 0;
		flex-direction: column;
		cursor: pointer;
		color: #5d8587;
		border: 1px solid transparent;
		border-radius: 12px;
		width: auto;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 8px 0;
		margin: 0 3px;
		background: transparent;
	}

	#app .footer .footer_item .footer_icon {
		display: inline-block;
		width: 26px;
		height: 26px;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		margin-bottom: 0;
	}

	

	#app .footer .footer_item .footer_info {
		font-size: 12px;
	}
	#app .footer .footer_item.footer_item_active .footer_info{
		font-weight: bold;
	}
	#app .footer .footer_item.footer_item_active {
		    background: #075761;
			border-color: #0a7780;
			box-shadow: inset 0 1px 0 rgba(255, 255, 255, .17), 0 4px 10px rgba(5, 64, 71, .2);
	}


#app .footer .footer_item .footer_icon.footer_icon_home {
		background-image: url(./views/images/foot/home.png);
	}
	#app .footer .footer_item .footer_icon.footer_icon_list {
		background-image: url(./views/images/foot/list.png);
	}
	#app .footer .footer_item .footer_icon.footer_icon_star {
		background-image: url(./views/images/foot/star.png);
	}
	#app .footer .footer_item .footer_icon.footer_icon_bag {
		background-image: url(./views/images/foot/money.png);
	}
	#app .footer .footer_item .footer_icon.footer_icon_user {
		background-image: url(./views/images/foot/user.png);
	}
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_home {
		background-image: url(./views/images/foot/homecur.png);
	}
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_list {
		background-image: url(./views/images/foot/listcur.png);
	}
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_star {
		background-image: url(./views/images/foot/starcur.png);
	}
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_bag {
		background-image: url(./views/images/foot/moneycur.png);
	}
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_user {
		background-image: url(./views/images/foot/usercur.png);
	}

	.red_top_bg {
		max-width: 750px;
		overflow: hidden;
		background-size: 100% 100%;
		position: relative;
		width: 100%;
		height: 50px;
		color: #f5dfbd;
	}
	#app .footer .footer_item .footer_icon.m1 {
		background: #287f83;
		-webkit-mask: url(./views/images/ban3/m1cur.png) no-repeat center / contain;
		mask: url(./views/images/ban3/m1cur.png) no-repeat center / contain;
		filter: none;
	}
	#app .footer .footer_item_active .footer_icon.m1 {
		background: #ffffff;
		-webkit-mask-image: url(./views/images/ban3/m1.png);
		mask-image: url(./views/images/ban3/m1.png);
	}
	#app .footer .footer_item .footer_icon.m2 {
		background: #287f83;
		-webkit-mask: url(./views/images/ban3/m2cur.png) no-repeat center / contain;
		mask: url(./views/images/ban3/m2cur.png) no-repeat center / contain;
		filter: none;
	}
	#app .footer .footer_item_active .footer_icon.m2 {
		background: #ffffff;
		-webkit-mask-image: url(./views/images/ban3/m2.png);
		mask-image: url(./views/images/ban3/m2.png);
	}
	#app .footer .footer_item .footer_icon.m3 {
		background: #287f83;
		-webkit-mask: url(./views/images/ban3/m3cur.png) no-repeat center / contain;
		mask: url(./views/images/ban3/m3cur.png) no-repeat center / contain;
		filter: none;
	}
	#app .footer .footer_item_active .footer_icon.m3 {
		background: #ffffff;
		-webkit-mask-image: url(./views/images/ban3/m3.png);
		mask-image: url(./views/images/ban3/m3.png);
	}
	#app .footer .footer_item .footer_icon.m4 {
		background: #287f83;
		-webkit-mask: url(./views/images/ban3/m4cur.png) no-repeat center / contain;
		mask: url(./views/images/ban3/m4cur.png) no-repeat center / contain;
		filter: none;
	}
	#app .footer .footer_item_active .footer_icon.m4 {
		background: #ffffff;
		-webkit-mask-image: url(./views/images/ban3/m4.png);
		mask-image: url(./views/images/ban3/m4.png);
	}
	#app .footer .footer_item .footer_icon.m5 {
		background: #287f83;
		-webkit-mask: url(./views/images/ban3/m5cur.png) no-repeat center / contain;
		mask: url(./views/images/ban3/m5cur.png) no-repeat center / contain;
		filter: none;
	}
	#app .footer .footer_item_active .footer_icon.m5 {
		background: #ffffff;
		-webkit-mask-image: url(./views/images/ban3/m5.png);
		mask-image: url(./views/images/ban3/m5.png);
	}
	
	#app .footer .footer_item .footer_info {
		font-size: 12px;
	}
	#app .footer .footer_item.footer_item_active .footer_info{
		font-weight: bold;
	}
	#app .footer .footer_item.footer_item_active {
		color: #ffffff;
	}

	.top_right {
		position: absolute;
		font-size: 13px;
		line-height: 18px;
		color: #fffffd;
		top: 10px;
		right: 10px;
	}

	.limit {
		height: 20px;
		line-height: 20px;
		border-radius: 10px;
		background: rgba(241, 34, 17, 0.08);
		color: #f12211;
		text-align: center;
		padding: 0 7px;
		border: 1px solid #f12211;
		font-size: 12px;
	}

	.gray_btn {
		height: 20px;
		align-items: center;
		background: rgba(0, 0, 0, 0.3);
		font-size: 12px;
		text-align: center;
		color: #FFFFFF;
		border-radius: 10px;
		padding: 0 9px;
	}
	.rechargebtn{
		 // background: linear-gradient(270deg,#ffd543,#0c7f9e);
		 
		 background: linear-gradient(1turn, #FF6666, #ffd543);
	}
	.withdrawbtn{
		// background: linear-gradient(270deg,#ffd543,#3b58a4);
		
		background: linear-gradient(1turn, #339999, #ffd543);
	}
	.big_tit {
		position: absolute;
		height: 25px;
		font-size: 14px;
		font-weight: bold;
		line-height: 25px;
		top: 12px;
		left: 50%;
		transform: translateX(-50%);
	}

	.sub_btn {
		background: linear-gradient(1turn, #3b58a4, #ffd543);
		height: 30px;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
		width: 94px;
		border-radius: 5px;
	}

	.remove_btn {
		background: linear-gradient(117deg, rgba(254, 166, 0, 1) 0%, rgba(255, 188, 0, 1) 100%);
		height: 36px;
		line-height: 36px;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
		width: 94px;
		border-radius: 18px;
	}

	.home_tit {
		width: 100%;
		height: 22px;
		line-height: 22px;
		display: flex;
		align-items: center;
		justify-content: center;

		.line {
			width: 75px;
			height: 2px;
		}

		h5 {
			font-size: 16px;
			line-height: 22px;
			color: #000000;
			margin: 0 10px;
			font-weight: bold;
		}
	}

	.van-popup {
		max-width: 100%;
		margin: 0 auto;
		right: 0;
	}

	.back_left {
		width: 20px;
		height: 20px;
		background: url(./views/images/item/back.png) no-repeat center center;
		background-size: auto 100%;
		margin: 12px 0 0 8px;
	}
	.getcode,.btn {
		background: #0063d2 !important;
		color: #fffffd !important;
	}
	.basic_btn {
		width: 100%;
		border-radius: 5px;
		color: #fff;
		text-align: center;
		background: linear-gradient(90deg, #5b60df, #5b60df) !important;
		color: #fffffd!important;
		height: 38px;
		line-height: 38px;
		font-size: 16px;
	}

	.basic_btn.no_touch {
		color: rgba(255, 255, 255, 0.5);
	}
	.basic_wrap .form{
		border-color: #D0B8A8;
		background-image: linear-gradient(to right bottom, rgb(37, 75, 98) 0%, rgb(29, 62, 83) 100%);
	}
	.flex_center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.wrap_box {
		// width: 100%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
	}

	.eye_bi {
		width: 21px;
		height: 25px;
		background: url(./views/images/user/eye2.png) no-repeat center center;
		background-size: 100% auto;

		&.eye {
			background: url(./views/images/user/eye1.png) no-repeat center center;
			background-size: 100% auto;
		}
	}

	.real_name_mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 30;
		background-color: rgba(0, 0, 0, 0.95);

		.real_box {
			width: 272px;
			height: 185px;
			background: rgba(255, 255, 255, 1);
			border-radius: 8px;
			position: absolute;
			top: 50%;
			left: 0;
			right: 0;
			margin: -92px auto 0 auto;

			.tit {
				width: 77px;
				height: 67px;
				position: absolute;
				top: -35px;
				left: 50%;
				transform: translateX(-50%);
				background: url(./views/images/user/tit.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.tips {
				width: 185px;
				height: 50px;
				text-align: center;
				font-size: 18px;
				color: #000000;
				line-height: 25px;
				position: absolute;
				top: 49px;
				left: 50%;
				transform: translateX(-50%);
			}

			.basic_btn {
				width: 225px;
				position: absolute;
				left: 0;
				right: 0;
				margin: 0 auto;
				bottom: 15px;
			}
		}
	}

	.contract_box img {
		width: 100%;
	}
	.kefu_img{
		border-radius: 80px;
	}
	.logo{
		width: 30vw;
		height: 30vw;
		margin-left: auto;
		margin-right: auto;
		.logoimg{
			height: 100%;
			width: 100%;
		}
	}
	.logourl{
		font-size: 6vw;
		line-height: 15vw;
		color: #FFF;
		text-align: center;
	}
	.item input{
		color: #000;
	}    
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #fffffd;
	    white-space: nowrap;
		border-radius: 2.66667vw;
		text-align: center;
		width: 95%;
		margin: 10px auto;
		color: #000;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #000;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 16px;
		    color: #000;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
	
	
	h3.box-title{
		margin: 4vw 0 5.33333vw 6.93333vw;
		font-size: 4.26667vw;
		font-weight: 400;
		color: #0063d2;
	}
	h2.page-title{
		font-size: 25px;
		font-weight: 700;
		color: #0063d2;
		padding: 2vh 5vw;
	}
	h3.page-title{
		color: #727d91;
		font-weight: 400;
		padding: 2vh 5vw;
		padding-top: 0;
	}
	.ismid{
		.itimg{
			position: relative;
			z-index: 1;
			margin: -2em auto 0;
			width: 5em;
			height: 5em;
			border-top: 1px solid #191d22;
			border-radius: 100%;
			background: #fff;
			.icon{
				width: 1.6em;
				height: 1.6em;
				padding-top: 0.3em;
			}
		}
		
	}
	.bgdeep {
		color: #282828;
		// background: linear-gradient(220.55deg, #FFADF7 0%, #B1FF96 100%) !important;
		// background: linear-gradient(0deg, rgba(229, 123, 130, 0.6), rgba(237, 87, 99, 0.6)) !important;
		background-color: #ffeee2;
	}
	.bglight {
		background: #0064d3;
		color: #fffffd;
	}
	.gun{
		background: linear-gradient(220.55deg, #FFADF7 0%, #B1FF96 100%) !important;
	}
	input::placeholder {
	    color: #999; /* 设置提示字符串颜色 */
	}
	.footimgs{
		height: 25px;
		margin: 0 5px;
		margin-top: 20px;
	}
	.footerdesc{
		text-align: center;
		font-size: 12px;
		line-height: 25px;
		margin-bottom: 65px;
		.version{
			font-weight: bold;
			margin-bottom: 20px;
			color: #000;
		}
		.copyright{
			margin: 5px 30px;
		}
	}
	.vip3span{
		padding: 3px 15px;
		background-color: #FFC107;
		border-radius: 5px;
		font-size: 14px;
		color: #000;
	}
	.vip2span{
		padding: 3px 15px;
		background-color:#c0c0c0;
		border-radius: 5px;
		font-size: 14px;
		color: #000;
	}
	.vip1span{
		padding: 3px 15px;
		background-color: #0064d3;
		border-radius: 5px;
		font-size: 14px;
		color: #fff;
	}
	.vip0span{
		padding: 3px 15px;
		background-color:yellow;
		border-radius: 5px;
		font-size: 14px;
		color: #000;
	}
	/* Order-matching loading messages need enough room for localized copy. */
	.toastc {
		width: 60% !important;
		max-width: 60% !important;
	}
	/* Centered request errors keep localized messages readable on mobile. */
	.app-error-toast {
		width: 70% !important;
		min-width: 0 !important;
		max-width: 70% !important;
		padding: 16px 20px !important;
		box-sizing: border-box;
		text-align: center;
	}
	.app-error-toast .van-toast__text {
		line-height: 20px;
		word-break: break-word;
	}
	/* Vote confirmation dialog. */
	.vote-confirm-dialog {
		width: calc(100% - 56px) !important;
		max-width: 360px;
		overflow: hidden;
		border: 1px solid rgba(190, 139, 52, .58);
		border-radius: 18px;
		background: #fffdf8 !important;
		box-shadow: 0 18px 42px rgba(83, 49, 38, .24), inset 0 1px #fff;
	}
	.vote-confirm-dialog .van-dialog__header {
		padding-top: 24px;
		color: #873126 !important;
		font-size: 18px;
		font-weight: 700;
		letter-spacing: 0;
	}
	.vote-confirm-dialog .van-dialog__content {
		padding: 0;
		background: transparent !important;
	}
	.vote-confirm-dialog .van-dialog__message {
		padding: 22px 26px;
		color: #63352c !important;
		font-size: 15px;
		line-height: 24px;
	}
	.vote-confirm-dialog .van-dialog__footer {
		display: flex;
		gap: 12px;
		padding: 0 20px 20px;
		background: transparent !important;
	}
	.vote-confirm-dialog .van-dialog__footer:after,
	.vote-confirm-dialog .van-dialog__confirm:before,
	.vote-confirm-dialog .van-hairline--left:after {
		display: none;
	}
	.vote-confirm-dialog .van-dialog__cancel,
	.vote-confirm-dialog .van-dialog__confirm {
		flex: 1;
		height: 46px;
		border: 1px solid rgba(190, 139, 52, .5);
		border-radius: 11px;
		font-size: 15px;
		line-height: 44px;
	}
	.vote-confirm-dialog .van-dialog__cancel {
		background: #fff7df !important;
		color: #815c45 !important;
	}
	.vote-confirm-dialog .van-dialog__confirm {
		border-color: rgba(166, 35, 61, .42);
		background: linear-gradient(105deg, #a6233d, #ca5a5b) !important;
		color: #fff8e8 !important;
	}
	/* The base footer rule appears later than the desktop canvas rule above. Reapply
	 * the fixed desktop width here so a large-screen footer stays under the app. */
	@media screen and (min-width: 768px) {
		#app .footer {
			width: 650px !important;
			max-width: 650px !important;
			left: 50% !important;
			right: auto !important;
			margin: 0 !important;
			transform: translateX(-50%);
		}
	}
</style>
